import type { ElementType, JSX } from 'react';

import type { ButtonProps } from '../Button/Button';
import Button from '../Button/Button';
import Spinners from '../Spinners/Spinners';

export default function LoadingButton<T extends ElementType>({
  isLoading,
  children,
  ...rest
}: ButtonProps<T> & { isLoading: boolean }): JSX.Element {
  return (
    <Button {...(rest as ButtonProps<T>)}>
      {isLoading ? <Spinners /> : <span>{children}</span>}
    </Button>
  );
}
